import React, { forwardRef } from "react";

import {
  calcStay,
  formatRoomTypes,
} from "./reservationExportUtils";

const ReservationTable = forwardRef(({
  reservations,
  setSelectedReservation,
  handleEdit,
}, ref) => {  //console.log(reservations);
  const getStatusColor = (reservationType) => {
    switch (reservationType) {
      case "Reservation":
        return "#d4f4e3";
      case "Check-in":
        return "#ddecff";
      case "Check-out":
        return "#fff2cc";
      case "Cancelled":
      case "Cancelled (hide)":
        return "#ffd6d6";
      case "No-show":
        return "#f3e5ff";
      case "Unconfirmed Reservation":
        return "#fff3b0";
      default:
        return "rgb(201, 233, 199)";
    }
  };

  return (
    <div ref={ref} style={{ width: "100%" }}>
      {/* Header */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr 2fr 1.5fr 1fr 1fr 1fr 1fr",
          backgroundColor: "#5ec3a4",
          color: "#fff",
          fontWeight: 700,
          padding: "12px 8px",
          borderRadius: "8px 8px 0 0",
          textAlign: "center",
        }}
      >
        {[
          "Check In",
          "Check Out",
          "Stay",
          "Hotel",
          "Room Type",
          "Guest",
          "Phone No",
          "Source",
          "Invoice",
        ].map((header) => (
          <div
            key={header}
            className={header === "Invoice" ? "export-hide" : undefined}
          >
            {header}
          </div>
        ))}
      </div>

      {/* Body */}
      <div style={{ marginTop: "8px" }}>
        {reservations.length ? (
          reservations.map((item) => (
            <div
              key={item.id}
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr 2fr 1.5fr 1fr 1fr 1fr 1fr", // match header
                backgroundColor: getStatusColor(item.reservationType),
                borderRadius: "8px",
                marginBottom: "8px",
                minHeight: "4em",
                alignItems: "center",
                cursor: "pointer",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  textDecoration: "underline",
                  color: "#2C9C84",
                  fontWeight: 500,
                }}
                onClick={() => handleEdit(item)}
              >
                {item.checkIn}
              </div>
              <div>{item.checkOut}</div>
              <div>{calcStay(item.checkIn, item.checkOut)} nights</div>
              <div>{item?.hotelName || "-"}</div>
              <div>{formatRoomTypes(item.roomDetails)}</div>
              <div>{item.firstName}</div>
              <div>{item.mobile}</div>
              <div>{item.source || "-"}</div>
              <div className="export-hide" style={{ textAlign: "center" }}>
                <button
                  // onClick={() => setSelectedReservation(item)}
                  onClick={() => {
                    window.open(`/admin/invoice?id=${item.id}`, "_blank");
                  }}
                  style={{
                    border: "none",
                    background: "transparent",
                    cursor: "pointer",
                  }}
                >
                  <i
                    className="fa-solid fa-eye"
                    style={{ color: "#4CBC9A", fontSize: "16px" }}
                  ></i>
                </button>
              </div>
            </div>
          ))
        ) : (
          <div
            style={{
              textAlign: "center",
              padding: "20px",
              fontStyle: "italic",
              color: "#888",
            }}
          >
            No reservations found
          </div>
        )}
      </div>
    </div>
  );
});

ReservationTable.displayName = "ReservationTable";

export default ReservationTable;
